import React, { forwardRef, ForwardRefRenderFunction, memo } from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import styles from "./gen-textfield.module.css";

export interface GenTextFieldProps extends Omit<TextFieldProps, "error"> {
  error?: string;
  accept?: string;
}

const GenTextField: ForwardRefRenderFunction<
  TextFieldProps,
  GenTextFieldProps
> = (props, ref) => {
  const {
    error,
    placeholder,
    helperText,
    className,
    required,
    label,
    ...otherProps
  } = props;

  return (
    <TextField
      fullWidth
      inputRef={ref}
      label={
        required ? (
          <Typography color="text.disabled">
            {label || "Required"}
            <Typography component="span" color="error">
              *
            </Typography>
          </Typography>
        ) : label ? (
          <Typography color="text.disabled">{label}</Typography>
        ) : undefined
      }
      className={className || styles.numberInput}
      error={!!error}
      placeholder={placeholder}
      helperText={
        <Typography
          component="span"
          variant="caption"
          color={error ? "error" : "secondary.light"}
        >
          {error || helperText}
        </Typography>
      }      
      margin="dense"
      size="small"
      onKeyDown={(e) => {
        if (e.key === "Backspace" || e.key === "Delete") {
          e.nativeEvent.stopImmediatePropagation();
        }
      }}
      {...otherProps}
    />
  );
};

export default memo(forwardRef(GenTextField));
